/* eslint-disable no-useless-escape */
export const rootWinPath = /^([a-zA-Z]:)/;
export const windowsInvalidPath =
  /^(\\)|^(\\)(?!(\\[A-Za-z0-9 _\-.]*\\))|^(%)(?!([A-Za-z0-9 _\-.]*%\\))|^([A-Z])(?=[^:])|^([A-Z])(?!.)|^([A-Z]:)(?!.)|^([A-Z]:)(?=[^\\])|^[^A-Z%\\]|(\\{3,}|\/|[<>"|?*])/;
export const windowsUpperCaseInvalidPath =
  /^(\\)|^(\\)(?!(\\[A-Za-z0-9 _\-.]*\\))|^(%)(?!([A-Za-z0-9 _\-.]*%\\))|^([A-Za-z])(?=[^:])|^([A-Za-z])(?!.)|^([A-Za-z]:)(?!.)|^([A-Za-z]:)(?=[^\\])|^[^A-Za-z%\\]|(\\{3,}|\/|[<>"|?*])/;
export const windowsNetworkInvalidPath =
  /^(%)(?!([A-Za-z0-9 _\-.]*%\\))|^([A-Z])(?=[^:])|^([A-Z])(?!.)|^([A-Z]:)(?!.)|^([A-Z]:)(?=[^\\])|^[^A-Z%\\]|(\\{3,}|\/|[<>"|?*])/;
export const linuxInvalidPath = /^[^/]|(\/{3,})/;
// linuxInvalidPath plus the %Variable%/path form windowsInvalidPath allows, with the separator the other way round
export const unixWithVariablesInvalidPath = /^(%)(?!([A-Za-z0-9 _\-.]*%\/))|^[^/%]|(\/{3,})/;
export const networkValidPath = /^(\\\\[^/\\":|<>?* ]+\\[^/\\":|<>?*]+)((?:\\[^\\/:*?"<>|]+)*\\?)$/i;
export const destinationValidator = /[/\\:*?"<>|()\[\]]/;
export const destinationToVMValidator = /[/\\:*?"<>|\[\]]/;
export const sqlServerInstanceValidator = /[/:*?"<>|]/;
export const PatternNameWithId = /^\d+ \(/;
export const HostDataMask = /["%:?()_\-+={}[]|:]/;
